<template>
    <div class="registration-wrapper">
        <!-- Step 0: Country Selection -->
        <select-country-step
            v-if="currentStep === 0"
            :form-data="formData"
            @update:formData="updateFormData"
            @next-step="nextStep"
        />

        <!-- Step 1: User Info -->
        <user-info-step
            v-if="currentStep === 1"
            :form-data="formData"
            @update:formData="updateFormData"
            @next-step="nextStep"
            @prev-step="prevStep"
        />

        <!-- Step 2: Account Creation -->
        <account-step
            v-if="currentStep === 2"
            :form-data="formData"
            :is-submitting="isSubmitting"
            :server-errors="serverErrors"
            @update:formData="updateFormData"
            @submit="submitRegistration"
            @prev-step="prevStep"
        />
        <!-- Note: Success is now shown on the waiting page (/register-tenant/waiting/{id}) -->
    </div>
</template>

<script>
import SelectCountryStep from './Steps/SelectCountryStep.vue'
import UserInfoStep from './Steps/UserInfoStep.vue'
import AccountStep from './Steps/AccountStep.vue'
import axios from 'axios'

export default {
    name: 'TenantRegistrationNew',
    components: {
        SelectCountryStep,
        UserInfoStep,
        AccountStep,
    },
    props: {
        plans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            currentStep: 0,
            isSubmitting: false,
            serverErrors: {},
            formData: {
                // Country
                country: '',

                // User Info (Step 1)
                nom: '',
                prenom: '',
                email: '',
                telephone: '',
                phoneCountryCode: '+33',
                entreprise: '',

                // Account (Step 2)
                subdomain: '',
                password: '',
                passwordConfirmation: '',
                acceptTerms: false,
                acceptOffers: false,

                // Plan
                plan_id: 1,

                // Language
                language: 'fr',
            },
        }
    },
    methods: {
        updateFormData(newData) {
            this.formData = { ...this.formData, ...newData }
        },
        nextStep() {
            if (this.currentStep < 3) {
                this.currentStep++
                window.scrollTo(0, 0)
            }
        },
        prevStep() {
            if (this.currentStep > 0) {
                this.currentStep--
                window.scrollTo(0, 0)
            }
        },
        async submitRegistration() {
            this.isSubmitting = true
            this.serverErrors = {}

            try {
                const payload = {
                    name: `${this.formData.prenom} ${this.formData.nom}`.trim(),
                    email: this.formData.email,
                    password: this.formData.password,
                    password_confirmation: this.formData.passwordConfirmation,
                    subdomain: this.formData.subdomain,
                    workPhone: `${this.formData.phoneCountryCode}${this.formData.telephone.replace(/^0+/, '')}`,
                    company_name: this.formData.entreprise,
                    country: this.formData.country, // Selected in Step 0
                    language: 'fr', // Always default to French, disregarding previous this.$i18n.locale value
                    agreeToTerms: this.formData.acceptTerms,
                    subscribeToMarketing: this.formData.acceptOffers,
                    plan_id: this.formData.plan_id,
                }

                console.log('Submitting registration payload:', payload)

                // Step 1: Pre-Submission availability check
                const checkPayload = {
                    email: this.formData.email,
                    subdomain: this.formData.subdomain,
                }

                console.log('Checking availability:', checkPayload)

                try {
                    await axios.post('/register-tenant/check-availability', checkPayload, {
                        headers: { Accept: 'application/json' },
                    })
                } catch (error) {
                    this.$toast.error(error.response.data.message)
                    throw error // Fall through to main catch for other errors
                }

                const response = await axios.post('/register-tenant', payload, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    timeout: 120000, // 2 minutes timeout for long API calls
                })

                console.log('Registration response:', response.data)
                console.log('Response success value:', response.data?.success, 'Type:', typeof response.data?.success)

                // Check for success - handle boolean, string 'true', and truthy values
                const isSuccess =
                    response.data &&
                    (response.data.success === true ||
                        response.data.success === 'true' ||
                        response.data.success === 1 ||
                        response.data.success === '1')

                if (isSuccess) {
                    // Redirect to waiting page for async provisioning
                    const tenantId =
                        response.data.tenant_id || response.data.id || (response.data.tenant && response.data.tenant.id)
                    console.log('Registration successful! Redirecting to waiting page for tenant:', tenantId)
                    window.location.href = `/register-tenant/waiting/${tenantId}`
                } else {
                    console.error('Registration failed:', response.data)
                    this.serverErrors = response.data.errors || {
                        general: response.data.message || 'Inscription échouée. Veuillez réessayer.',
                    }
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                if (error.response && error.response.data) {
                    console.error('Error response data:', error.response.data)
                    if (error.response.data.errors) {
                        this.serverErrors = error.response.data.errors
                    } else if (error.response.data.message) {
                        this.serverErrors = { general: error.response.data.message }
                    } else {
                        this.serverErrors = { general: 'Une erreur inattendue est survenue. Veuillez réessayer.' }
                    }
                } else if (error.code === 'ECONNABORTED') {
                    this.serverErrors = { general: 'La requête a pris trop de temps. Veuillez réessayer.' }
                } else {
                    this.serverErrors = { general: 'Une erreur inattendue est survenue. Veuillez réessayer.' }
                }
            } finally {
                this.isSubmitting = false
            }
        },
    },
}
</script>

<style scoped>
.registration-wrapper {
    min-height: 100vh;
}
</style>
